import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVivaldi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#vivaldi_svg__a)' rx={9.5} />
    <defs>
      <pattern id='vivaldi_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#vivaldi_svg__b' transform='matrix(.0022 0 0 .0022 -.001 0)' />
      </pattern>
      <image
        xlinkHref='/images/icons/vivaldi-4bf03c77.webp'
        id='vivaldi_svg__b'
        width={456}
        height={455}
      />
    </defs>
  </svg>
);
export default SvgVivaldi;
